
export default {
  data() {
    return {
      showFixed: !this.$cookies.get('downShow') // 是否显示
    }
  },
  methods: {
    close() {
      this.showFixed = false
      this.$cookies.set('downShow', true, {
        path: '/',
        domain: this.$store.state.cookieHost,
        maxAge: 43200
      })
    },
    todown() {
      this.mdcountfn({
        event_name: 'Wiki_Business_Profile_DL'
      })
      const ua = navigator.userAgent.toLowerCase()
      const isAndroid = ua.includes('android') || ua.includes('linux')
      /** fxeyemaster海外版 fxeyechinesemaster中文版 */
      if (isAndroid) {
        // console.log('isAndroid')
        const iframe = document.createElement('iframe')
        iframe.src = 'wikifx://tans'
        iframe.style.display = 'none'
        document.body.appendChild(iframe)

        setTimeout(() => {
          window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/download.html`)
        }, 3000)
      } else {
        const url = window.location.host
        const CountryCode = this.$store.state.CountryCode
        console.log(url.includes('wikifx.com') || CountryCode != 'cn', 1111, CountryCode, 2222, CountryCode != 'cn', 3333, url, 4444, url.includes('wikifx.com'))
        if (url.includes('wikifx.com') || CountryCode != 'cn') {
          window.location = 'wikifxmaster://' // wikifx
        } else {
          window.location = 'fxeyemaster://' // wikifx
        }
        setTimeout(() => {
          window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/download.html`)
        }, 2000)
      }
    }
  }
}
